// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-footer {\n  background: #dcdcdc;\n  /* padding: .5rem 2rem; */\n  /* text-align: center; */\n  /* vertical-align: middle; */\n}\n\n.footer-message {\n  color: #595959;\n  font-family: sans-serif;\n}\n\n.footer-logo {\n  height: 24px;\n  width: 24px;\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
